
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/search/availabilityCalendar",
      function () {
        return require("private-next-pages/search/availabilityCalendar.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/search/availabilityCalendar"])
      });
    }
  